import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    '&.ant-btn': {
        height: '2.5rem',

        marginTop: '1rem',

        borderRadius: '1.25rem',
    },
});
